import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';

import { EmedUiSharedModule, HttpLoaderFactory } from '@multimediasrl/emed-ui-shared';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

import { TooltipModule } from 'primeng/tooltip';
import { ButtonModule } from 'primeng/button';
import { ChartModule } from 'primeng/chart';
import { CardModule } from 'primeng/card';
import { MultiSelectModule } from 'primeng/multiselect';
import { TableModule } from 'primeng/table';
import { PanelModule } from 'primeng/panel';
import { AccordionModule } from 'primeng/accordion';
import { SelectModule } from 'primeng/select';
import { TabsModule } from 'primeng/tabs';
import { DatePickerModule } from 'primeng/datepicker';
import { MenubarModule } from 'primeng/menubar';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { CheckboxModule } from 'primeng/checkbox';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TagModule } from 'primeng/tag';
import { FileUploadModule } from 'primeng/fileupload';

import { environment } from '../../../environments/environment';

import { EmedFieldErrorComponent } from './components/emed-field-error/emed-field-error.component';
import { EmedPageHeaderComponent } from './components/emed-page-header/emed-page-header.component';
import { EmedFormDialogComponent } from './components/emed-form-dialog/emed-form-dialog.component';
import { EmedFilterPanelComponent } from './components/emed-filter-panel/emed-filter-panel.component';

@NgModule({
  declarations: [EmedFieldErrorComponent, EmedPageHeaderComponent, EmedFormDialogComponent, EmedFilterPanelComponent],
  imports: [
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    EmedUiSharedModule.forRoot({
      production: environment.production,
      baseUrl: environment.baseUrl,
      localStorageID: environment.localStorageID
    }),
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    TooltipModule,
    ChartModule,
    CardModule,
    FormsModule,
    MultiSelectModule,
    TableModule,
    PanelModule,
    AccordionModule,
    SelectModule,
    TabsModule,
    DatePickerModule,
    MenubarModule,
    DialogModule,
    InputTextModule,
    InputNumberModule,
    CheckboxModule,
    ToggleSwitchModule,
    ConfirmDialogModule,
    TagModule,
    FileUploadModule
  ],
  exports: [
    EmedFieldErrorComponent,
    EmedPageHeaderComponent,
    EmedFormDialogComponent,
    EmedFilterPanelComponent,
    EmedUiSharedModule,
    ButtonModule,
    TooltipModule,
    ChartModule,
    CardModule,
    FormsModule,
    MultiSelectModule,
    TableModule,
    PanelModule,
    AccordionModule,
    SelectModule,
    TabsModule,
    DatePickerModule,
    MenubarModule,
    DialogModule,
    InputTextModule,
    InputNumberModule,
    CheckboxModule,
    ToggleSwitchModule,
    ConfirmDialogModule,
    TagModule,
    FileUploadModule
  ],
  providers: []
})
export class SharedModule {}
